export const CLOSE_TAB_FOOTER = 'close_tab_footer';
export const OPEN_TAB_FOOTER = 'open_tab_footer';
export const CHANGE_TAB_MENU = 'change_tab_menu';
export const CHANGE_PROJECT = 'change_project';
export const CHANGE_VERIFICATION = 'change_verification';
export const CLEAN_MONITOR_MSG = 'clean_monitor_msg';
export const DEBUG_MONITOR = 'debug_monitor';
export const CHANGE_CCC_MENU = 'change_ccc_menu';
export const CLEAN_TAB_MONITOR_STATUS = 'clean_tab_monitor_status';